import { render, staticRenderFns } from "./linkpay.vue?vue&type=template&id=cf220f44&scoped=true&"
import script from "./linkpay.vue?vue&type=script&lang=js&"
export * from "./linkpay.vue?vue&type=script&lang=js&"
import style0 from "./linkpay.vue?vue&type=style&index=0&id=cf220f44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf220f44",
  null
  
)

export default component.exports